define('photogallery',["jquery", "knockout", "knockout.mapping", "swiper", "api"], function ($, ko, mapping, swiper, api) {
  var loadCss = function(url) {
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
  };

  return function () {
    var me = this;
    var gallery = null;
    var app;

    me.isVisible = ko.observable(false);
    me.photos = ko.observableArray();
    me.initialSlide = 0;
    me.kind = "images";
    me.entity = ko.observable();

    me.init = function (parameters, application) {
      app = application;
      me.initialSlide = Math.max(0, parseInt(ko.unwrap(parameters.selectedIndex), 10) || 0);
      me.kind = parameters.kind || me.kind;
      
      // The website includes Swiper in its stylesheet. Retain the standalone
      // stylesheet for the legacy app, which has a separate asset bundle.
      if (application.isApp) loadCss(api.absoluteUrlToRelative("/Content/libs/swiper/css/swiper.min.css"));
      if (parameters.venueId) {
        me.entity("venue");
        (parameters.photoRequest || api.get("/api/venues/" + parameters.venueId + "/photos?kind=" + encodeURIComponent(me.kind)))
          .done(function(photos) {
            me.photos(photos);
            window.setTimeout(function() {
              me.open();
            }, 0);
          });
      } else if (parameters.eventId) {
          me.entity("event");
          api.get("/api/events/" + parameters.eventId + "/photos")
              .done(function(photos) {
                  me.photos(photos);
                  window.setTimeout(function() {
                      me.open();
                  }, 0);
              });
      } else if (parameters.postId) {
          me.entity("event");
          api.get("/api/posts/" + parameters.postId + "/photos")
              .done(function(photos) {
                  me.photos(photos);
                  window.setTimeout(function() {
                      me.open();
                  }, 0);
              });        
      } else {
          me.photos(parameters.photos);
          window.setTimeout(function() {
              me.open();
          }, 0);
      } 
    };

    me.open = function() {
      app.navigation.navigate("photogallery", false, true, me.close);
      
      $("html").addClass("fullscreen");
      me.isVisible(true);
      gallery = new swiper(".swiper-container", {
        pagination: '.swiper-pagination',
        paginationClickable: true, 
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        keyboard: true,
        preloadImages: false,
        lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
        initialSlide: me.initialSlide  
      });

      gallery.lazy.loadInSlide(me.initialSlide);
    };

    me.close = function() {
      $("html").removeClass("fullscreen");
      me.isVisible(false);
      gallery.destroy(true, true);
      me.unload();
    };
    
    me.closeButton = function () {
        app.navigation.back();
    };

    return me;
  };
});

